<!--
  An ElAutocomplete specialized for Contexts
-->

<template>
  <el-autocomplete style="width: 100%"
    :clearable="clearable"
    :value="value"
    v-on="$listeners"
    :placeholder="placeholder"
    :fetch-suggestions="searchContext"
    v-bind="$attrs">
    <template slot-scope="{ item }">
      <span class="context-autocomplete__left" v-if="item.left">{{ item.left }}</span>
      <strong class="context-autocomplete__match" v-if="item.match">{{ item.match }}</strong>
      <span class="context-autocomplete__right" v-if="item.right">{{ item.right }}</span>
      <span class="context-autocomplete__count"> ({{item.count}})</span>
    </template>
    <template slot="prefix" v-if="$slots.prefix">
      <slot name="prefix"></slot>
    </template>
    <template slot="suffix" v-if="$slots.suffix">
      <slot name="suffix"></slot>
    </template>
    <template slot="prepend" v-if="$slots.prepend">
      <slot name="prepend"></slot>
    </template>
    <template slot="append" v-if="$slots.append">
      <slot name="append"></slot>
    </template>
  </el-autocomplete>
</template>

<script>
import { filterSuggestions } from '../../utils/filter.js'

export default {
  name: 'ElContextInput',

  props: {
    value: String,
    placeholder: String,
    contexts: Array,
    clearable: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    searchContext (query, cb) {
      cb(filterSuggestions(query, this.contexts.map(c => {
        return {
          value: c.context,
          count: c.count,
        }
      })))
    },
  },
}
</script>

<style lang="scss">
  @import "../../element-variables.scss";

  .context-autocomplete__count {
    color: $--color-text-placeholder;
  }
</style>
